import React from 'react';
import LegalPage from '../components/LegalPage';

const PrivacyPage = () => (
  <LegalPage title="Privacy Notice" updatedAt="July 2026">
    <p>
      DreamDate is a client-side app. When you bring your own Anthropic API
      key, your browser fetches the roleplay instructions for your chosen
      character from a small DreamDate server, then sends your conversation
      straight to Anthropic — we never see the conversation itself. If you use
      the optional "Try it out" trial instead, that same server relays your
      messages to Anthropic — see "Trial mode" below.
    </p>

    <h2>Your API key</h2>
    <p>
      The Anthropic API key you enter is saved only in your browser's local
      storage, on your own device. It is never sent to DreamDate or any
      server we operate. It's used only to authenticate requests your browser
      sends directly to Anthropic. You can remove it at any time with the
      "Remove API Key" button, or by clearing your browser's local storage.
    </p>

    <h2>Your conversations</h2>
    <p>
      Chat messages and feedback exist only in your browser's memory for the
      current session. We don't store, log, or have access to them. Closing the
      tab or refreshing the page clears them.
    </p>
    <p>
      The randomly generated character you practice with — a fictional name,
      age, and job, invented in your browser and containing nothing about you —
      is sent to the DreamDate server so it can build that character's roleplay
      instructions. It isn't stored or logged.
    </p>
    <p>
      To generate replies, your messages are sent directly from your browser
      to Anthropic using your API key. That exchange is governed by{' '}
      <a href="https://www.anthropic.com/legal/privacy" target="_blank" rel="noopener noreferrer">
        Anthropic's own privacy policy
      </a>{' '}
      and the terms of your Anthropic account — not by us, since we never see
      that traffic.
    </p>

    <h2>Trial mode ("Try it out")</h2>
    <p>
      If you use the free trial instead of your own API key, your messages are
      sent to a DreamDate server, which forwards them to Anthropic using the
      owner's API key. To keep the trial to a couple of free chats, the server
      keeps a temporary count in memory, keyed by a random id stored in a
      cookie and by your IP address. That count holds no conversation content,
      is best-effort, and is lost whenever the server restarts. Trial messages
      themselves aren't stored.
    </p>

    <h2>Hosting and analytics</h2>
    <p>
      The app is served as static files. Our hosting provider may keep
      standard, short-lived infrastructure logs (like IP address and request
      time) purely to operate and secure the service. We don't run any
      analytics, tracking, or advertising scripts of our own.
    </p>

    <h2>Cookies</h2>
    <p>
      In trial mode, DreamDate sets a single cookie — a random trial id used
      only to count your free chats. Otherwise it sets no cookies; the only
      other browser storage it uses is local storage, for your API key.
    </p>

    <h2>Changes</h2>
    <p>
      If this notice changes, we'll update the date at the top of this page.
    </p>
  </LegalPage>
);

export default PrivacyPage;
